import { createModal } from '/@/core/elements/modal'
import { type SpoakSignType } from '/@/common/SpoakSign/types'

export interface SpoakSignModalData {
  sign: SpoakSignType | null
}

const { api, component } = createModal<SpoakSignModalData>(
  'SpoakSignModal',
  () => import('./SpoakSignModal.vue'),
  {
    sign: null,
  },
)

export const useSpoakSignModal = api
export default component
